import request from '@/utils/request'

let ReportApi = {

  /*商品销售报表*/
  product(data) {
    return request._post('/shop/report/product', data);
},
// 司机报表
driver(data) {
  return request._post('/shop/report/driver', data);
},
//销售毛利统计
salestable(data) {
  return request._post('/shop/report/salestable', data);
},
//损耗统计
getLossStatisticssalestable(data) {
  return request._post('/shop/report/getLossStatisticssalestable', data);
},
//进销存
getInventoryFlow(data) {
  return request._post('/shop/report/getInventoryFlow', data);
},

}
export default ReportApi;



// WEBPACK FOOTER //
// ./src/api/report.js